/* eslint 'jsx-a11y/anchor-is-valid': 'off' */
import React, { Component } from "react";
import { connect } from 'react-redux';
import { Button,Table } from 'reactstrap';
import { createFilter } from 'react-search-input';
import '../../../Assets/EnsembleStyles/BillingInvoices.css';
import { Redirect } from 'react-router-dom';
import { GetCampusBuildingInvoiceByBuildingId, ASUGenerateSummaryInvoice, DownlodBuildingInvoiceExcel } from '../../../action/ASU/BillingInvoicesAction';
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { FaRegCalendarAlt } from 'react-icons/fa';
import '../../../Assets/EnsembleStyles/BillingInvoices.css';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
//import DownloadInvoice from '../../../Assets/icons/DownloadInvoice.svg';
import Conversions from '../../../Resources/Conversions';
//import { FaPrint } from 'react-icons/fa';
import ASULogo from '../../../Assets/images/ASU-logo-horizontal_02.png';
import {Icon} from 'semantic-ui-react';

let CampusBuildingId, SiteName, FilteredData = [], FilteredData1 = [],dateformat = "";
const month = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const KEYS_TO_FILTERS = ['invoiceDate', 'on_Peak_kw', 'off_Peak_kw', 'kWh_Total', 'kWh_Cost', 'tonHr_Total', 'tonHr_Cost', 'heating_mmBTU', 'heating_mmBTU_Cost', 'total_mmBTU', 'om_Utility_Service_Charge', 'om_Capital_Service_Charge', 'sewer_Service_Charge', 'water_Service_Charge', 'total_Cost'];
const ErrorPadding ={
    color:'#D42D27',
    fontfamily:'Lato',
    fontSize:'13px',
    fontStyle:'italic',
    border:'2px solid #D42D27',
    height:'40px',
    padding:'10px',
    float:'right',
    marginTop:'-5px',
    marginBottom:'5px'    
};
const ErrorSign ={
    color:'#D42D27',
    paddingLeft:'8px',
    paddingTop:'0px',
    paddingRight:'14px',
    width:'22px',
    height:'22px',
    top:'406px',
    left:'959px'
};
class ASUInvoicesForBuilding extends Component {

    componentWillMount() {
        CampusBuildingId = this.props.building;
        SiteName = this.props.siteName;
        FilteredData = [];

        var FilterDetails = sessionStorage.getItem('ASUInvoiceTabFilter');
        if (FilterDetails !== undefined && FilterDetails !== null && FilterDetails !== "null") {
            var lFilterDetails = JSON.parse(FilterDetails);
            this.props.GetCampusBuildingInvoiceByBuildingId(CampusBuildingId, lFilterDetails.InvoiceFilterYear);
            var FilterDt = new Date();
            FilterDt.setDate(1);
            FilterDt.setMonth(lFilterDetails.InvoiceFilterMonth - 1);
            FilterDt.setFullYear(lFilterDetails.InvoiceFilterYear);
            this.setState({ FilterDate: FilterDt });
        }
        else {
            this.props.GetCampusBuildingInvoiceByBuildingId(CampusBuildingId, 2020);
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            redirectHome: false,
            searchTerm: "",
            FilterYearValue: 'All',
            isError: false,
            FilterDate: new Date(),
            columnDefs: [
                {
                    headerName: "", width: 50, field: "checkboxfield", cellStyle: { 'padding-top': '12px' }, pinned: 'left', sortable: false, cellRenderer: (params) => {
                        var link = document.createElement('input');
                        link.type = 'checkbox';
                        link.checked = params.value;
                        link.value = params.data.invoiceDate;
                        link.className = "ASUBuildingInvoiceGeneration"
                        return link;
                    }
                },
                { headerName: "Invoice Date", field: "invoiceDate", pinned: 'left',sortingOrder: ['asc', 'desc'],comparator: this.MonthComparator, sort: 'asc' },
                { headerName: "On-Peak kW", tooltip: (params) => params.value, field: "on_Peak_kw", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                { headerName: "Off-Peak kW",tooltip: (params) => params.value, field: "off_Peak_kw", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                { headerName: "kWh Total",tooltip: (params) => params.value, field: "kWh_Total", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                { headerName: "kWh Cost", tooltip: (params) => params.value, field: "kWh_Cost", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                { headerName: "TonHr Total",tooltip: (params) => params.value, field: "tonHr_Total", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                { headerName: "TonHr Cost", tooltip: (params) => params.value, field: "tonHr_Cost", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                { headerName: "Heating mmBTU", tooltip: (params) => params.value, field: "heating_mmBTU", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                { headerName: "Heating mmBTU COST", tooltip: (params) => params.value, field: "heating_mmBTU_Cost", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                { headerName: "Total mmBTU", tooltip: (params) => params.value, field: "total_mmBTU", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                { headerName: "O&M Utility Service Charge", tooltip: (params) => params.value, field: "om_Utility_Service_Charge", headerTooltip: 'O&M UTILITY SERVICE CHARGE', cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                { headerName: "O&M Capital Service Charge", tooltip: (params) => params.value, field: "om_Capital_Service_Charge", headerTooltip: 'O&M CAPITAL SERVICE CHARGE', cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                { headerName: "Sewer Service Charge", tooltip: (params) => params.value, field: "sewer_Service_Charge", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                { headerName: "Water Service Charge", tooltip: (params) => params.value, field: "water_Service_Charge", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                { headerName: "Total Cost", tooltip: (params) => params.value, field: "total_Cost", pinned: 'right', cellStyle: { 'text-align': 'center', 'font-weight': 'bolder' }, headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator }]
        };
        this.OnFilterYearChange = this.OnFilterYearChange.bind(this);
        this.OnFilterChange = this.OnFilterChange.bind(this);
        this.searchUpdated = this.searchUpdated.bind(this);
        this.setFilterDate = this.setFilterDate.bind(this);
        this.onFilterCalendarOpen = this.onFilterCalendarOpen.bind(this);
        this.onFilterCalendarClose = this.onFilterCalendarClose.bind(this);
        this.OpenPrintPreview = this.OpenPrintPreview.bind(this);

    }

    
    NumberComparator(Number1, Number2,nodeA, nodeB) { 
        if(nodeB.lastChild === true || nodeA.lastChild === true)
           return null;
       
        Number1 = Number1.replace('$',"");
        Number2 = Number2.replace('$',"");

        let PreferedDateFormat = dateformat;
        var n1 = Conversions.getInvariantNumber(PreferedDateFormat, Number1);
        var n2 = Conversions.getInvariantNumber(PreferedDateFormat, Number2);      

        return (n1 - n2);
    }

    DownloadExcel() {
        this.setState({isError: false});
        var Data = [];
        var checkboxes = document.getElementsByClassName('ASUBuildingInvoiceGeneration');
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked === true) {
                var Invoice_id_to_be_generated = {
                    "invoiceDate": checkboxes[i].value,
                    "buildingId": CampusBuildingId
                }
                Data.push(Invoice_id_to_be_generated);
            }
        }
        if(Data.length)
            Data.reduce((promiseChain, arrayItem) => promiseChain.then(() => this.props.DownlodBuildingInvoiceExcel(arrayItem)), Promise.resolve());
        else
            this.setState({isError: true});
    }

    MonthComparator(Month1, Month2,nodeA, nodeB) { 
          
        let nameA, nameB,yearA,yearB;
        if(nodeB.lastChild === true || nodeA.lastChild === true)
           return null;
        
        nameA = month.indexOf(Month1.split(" ")[0]);
        nameB = month.indexOf(Month2.split(" ")[0]);
        yearA = parseInt(Month1.split(" ")[1]);
        yearB = parseInt(Month2.split(" ")[1]);

        if(yearA !== yearB)
          return (yearA - yearB);
        else
          return (nameA - nameB);

    }

    changeBottomRow(params) {
        if (params.data.invoiceDate === 'Total') {
            return 'bottom-row-style';
        }
    }

    calculateColMax(colId) {
        let max = 0;
        let PreferedDateFormat = this.props.UserPreference_response;
        FilteredData1.forEach(item => {
            if (Number(item[colId]) > max) {
                max = Number(item[colId]);
            }
        });
        max = Conversions.formatNumber(PreferedDateFormat, max);
        return max;
    }

    setFilterDate(date) {
        this.setState({ FilterDate: date });
    }

    onFilterCalendarOpen() {
        var aa = document.getElementsByClassName('react-datepicker__tab-loop');
        aa[0].id = "asu_wrapper_calendar";
        // var SelectedYear = document.getElementsByClassName('react-datepicker__header react-datepicker-year-header')[0].innerText;
        // Number(SelectedYear) === new Date().getFullYear() ? "#4C912D" : "#000000";
    }

    OnFilterChange() {
        this.props.GetCampusBuildingInvoiceByBuildingId(CampusBuildingId, this.state.FilterDate.getFullYear());
    }

    onGridReady(params) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
    }

    onExportInvoice(){
        //this.gridApi.paginationGoToLastPage();
        const params = {
            columnGroups: true,
            allColumns: true,
            fileName: 'Building_Details_List',
            columnSeparator:''
            
          };
          this.gridApi.exportDataAsCsv(params);
    }

    OnGenerateASUPDF() {

        //     var data = [], lineitem = '';
        //     this.state.tenants_invoice_data_in_state.forEach(element => {
        //         lineitem = {
        //             "tenantId": element.tenantId,
        //             "startDate":  this.state.start_date, //this.FormValidDate(this.state.start_date),
        //             "endDate": this.state.end_date, //this.FormValidDate(this.state.end_date),
        //             "meterCharges":element.consumptionDetails.length > 0 ? element.consumptionDetails : null,
        //             "fixedCharges":element.fixedChargeDetails.length > 0 ? element.fixedChargeDetails : null
        //         }
        //     data.push(lineitem);
        // });
        //     data.reduce((promiseChain, arrayItem) => promiseChain.then(() => this.props.GenerateInvoice(arrayItem)),Promise.resolve());

        this.setState({isError: false});
        var Data = [];
        var checkboxes = document.getElementsByClassName('ASUBuildingInvoiceGeneration');
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked === true) {
                var Invoice_id_to_be_generated = {
                    "invoiceDate": checkboxes[i].value,
                    "buildingId": CampusBuildingId
                }
                Data.push(Invoice_id_to_be_generated);
            }
        }
        if(Data.length)
            Data.reduce((promiseChain, arrayItem) => promiseChain.then(() => this.props.ASUGenerateSummaryInvoice(arrayItem)), Promise.resolve());
        else
            this.setState({isError: true}); 
        //this.props.ASUGenerateSummaryInvoice(Data);

    }

    onFilterCalendarClose() {

    }

    OnFilterYearChange() {
        var selectedOption = this.refs.year_in_Select_input.options.selectedIndex;
        var lFilterId = this.refs.year_in_Select_input.options[selectedOption].id;
        this.setState({ FilterYearValue: lFilterId });
    }

    searchUpdated() {
        this.setState({ searchTerm: this.refs.asu_campus_search_value.value });
    }

    toggleCampusInvoiceList() {
        this.setState({ redirectHome: true });
    }

    OpenPrintPreview(){
        var CurrentDateTime = new Date(); 
        var CurrentTime = CurrentDateTime.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
        var CurrentDate = (CurrentDateTime.getMonth()+1) + '/' + CurrentDateTime.getDate() + '/' + CurrentDateTime.getFullYear() + ', ' + CurrentTime;
        var printContent = document.getElementById('divASUPrintWindow').outerHTML;
        var imgURL = document.getElementById('Asu_Logo').src;
        var SelectedDate = document.getElementById('FilterCalendar').value;
        //var SelectedCampus = this.state.FilterCampusValue === null ? "All" : this.state.FilterCampusValue;
        var WindowHeight = ((window.screen.height)-200) + 'px';
        var WindowWidth = ((window.screen.width)-10) + 'px';
        var printWindow = window.open('', 'printwindow', 'height='+WindowHeight+', width='+WindowWidth+', resizable=1, scrollbars=yes, layout=1');
        //create a new HEAD with the exact same content as the main page
        var writeMe = ('<html style="overflow: auto !important;"><body style="overflow: visible !important;"><head>' + document.getElementsByTagName('head')[0].innerHTML + '</head>');
        //grab the content of the printMe div and use it on the print page
        writeMe += ("<div style='display:block !important;' class='row row_padding'><div class='col-md-12'>");
        writeMe += ("<div id='asu_print_margin'><img id='asu_Logo' src=" + imgURL + ">");
        writeMe += ("<label class='workOrderlabel' style='float:right;margin-right:16px;margin-top:-25px'>" + CurrentDate + "</label></div>");
        writeMe += ("<label style='height: 15px;padding-left: 15px;'>Building: " + SiteName  + "</label><hr style='margin-bottom: 4px;background-color: gray;height: 2px;border: none;margin-top: 4px;margin-left: 15px;margin-right: 15px;'>");
        writeMe += ("<label style='vertical-align: bottom !important;margin-bottom: 0.3rem !important;padding-left: 16px; padding-bottom: 3px;'>Date: " + SelectedDate + "</label>");
        writeMe += ("<div id='divPrintPreview'>" + printContent + "</div>");
        writeMe += ("<br/><hr style='margin-bottom: 0px;background-color: gray;height: 2px;border: none;margin-top: 4px;margin-left: 15px;margin-right: 15px;'/><br/>");
        writeMe += ("<label class='print_footer' style='padding-left: 16px; padding-bottom: 8px;'>Tracer Ensemble<br/>© 2021 Trane Technologies | Privacy Policy | Terms of Use<br/>Page 1 of 1</label>");
        writeMe += ("<div style='margin-right:4px'><div style='float:right;'>");
        writeMe += ("<button type='button' class='hide_in_print' style='background: #BBBBBB 0% 0% no-repeat;border: 1px solid #999999;border-radius: 2px;opacity: 1;text-align: center;font-family: Lato;font-size: 12px;letter-spacing: 0.36px;color: #FFFFFF;width: 80px;height: 30px;float: right; margin-left: 6px; margin-right:10px; width:106px' id='btnPrint' onclick='javascript:window.close();' >Close Window</button>");
        writeMe += ("<button type='button' class='hide_in_print' style='background: #2070CF 0% 0% no-repeat;border: 1px solid #999999;border-radius: 2px;opacity: 1;text-align: center;font-family: Lato;font-size: 12px;letter-spacing: 0.36px;color: #FFFFFF;width: 101px;height: 30px;float: right; margin-left: 6px; id='btnPrint' onclick='javascript:window.print();' >Print</button>");
        writeMe += ("</div><br/>");
        writeMe += ('</body></html>');
        printWindow.document.write(writeMe);
        printWindow.document.close();
        if (window.focus) {
            printWindow.focus();
        } 
    }

    render(UserPreference_response) {
        if (this.state.redirectHome) {
            return <Redirect to={"/ManageASU"} />
        }
        let Data;
        // label = this.props.getLabels;
        FilteredData = [];
        Data = this.props.CampusSelectedBuildingInvoice;
        let PreferedDateFormat = this.props.UserPreference_response;
        dateformat = PreferedDateFormat;
        let CampusInvoiceDetailTable = [];

        if (this.state.isError) {
            var errormsg = <p style={ErrorPadding}>
                            <Icon name='exclamation triangle' style={ErrorSign}/>
                            <b>Select one or more months to perform this action.</b>
                           </p>
        }

        if (Data !== undefined && Data !== null && Data.length) {
            let StructuredData = [], UnstructuredData = [];
            var ItemRows = [];
            Data.forEach(el => {
                var lineitem = {
                    "invoiceDate": el.invoiceDate,
                    "on_Peak_kw": Conversions.formatNumber(PreferedDateFormat,el.on_Peak_kw),
                    "off_Peak_kw": Conversions.formatNumber(PreferedDateFormat,el.off_Peak_kw),
                    "kWh_Total": Conversions.formatNumber(PreferedDateFormat,el.kWh_Total),
                    "kWh_Cost": "$" + Conversions.formatNumber(PreferedDateFormat,el.kWh_Cost),
                    "tonHr_Total": Conversions.formatNumber(PreferedDateFormat,el.tonHr_Total),
                    "tonHr_Cost": "$" + Conversions.formatNumber(PreferedDateFormat,el.tonHr_Cost),
                    "heating_mmBTU": Conversions.formatNumber(PreferedDateFormat,el.heating_mmBTU),
                    "heating_mmBTU_Cost": "$" + Conversions.formatNumber(PreferedDateFormat,el.heating_mmBTU_Cost),
                    "total_mmBTU": Conversions.formatNumber(PreferedDateFormat,el.total_mmBTU),
                    "om_Utility_Service_Charge": "$" + Conversions.formatNumber(PreferedDateFormat,el.om_Utility_Service_Charge),
                    "om_Capital_Service_Charge": "$" + Conversions.formatNumber(PreferedDateFormat,el.om_Capital_Service_Charge),
                    "sewer_Service_Charge": "$" + Conversions.formatNumber(PreferedDateFormat,el.sewer_Service_Charge),
                    "water_Service_Charge": "$" + Conversions.formatNumber(PreferedDateFormat,el.water_Service_Charge),
                    "total_Cost": "$" + Conversions.formatNumber(PreferedDateFormat,el.total_Cost)
                }

                var lineitem1 = {
                    "invoiceDate": el.invoiceDate,
                    "on_Peak_kw": el.on_Peak_kw,
                    "off_Peak_kw": el.off_Peak_kw,
                    "kWh_Total": Number(Number(el.kWh_Total).toFixed(2)),
                    "kWh_Cost":  Number(Number(el.kWh_Cost).toFixed(2)),
                    "tonHr_Total":  Number(Number(el.tonHr_Total).toFixed(2)),
                    "tonHr_Cost":  Number(Number(el.tonHr_Cost).toFixed(2)),
                    "heating_mmBTU":  Number(Number(el.heating_mmBTU).toFixed(2)),
                    "heating_mmBTU_Cost":  Number(Number(el.heating_mmBTU_Cost).toFixed(2)),
                    "total_mmBTU":  Number(Number(el.total_mmBTU).toFixed(2)),
                    "om_Utility_Service_Charge":  Number(Number(el.om_Utility_Service_Charge).toFixed(2)),
                    "om_Capital_Service_Charge":  Number(Number(el.om_Capital_Service_Charge).toFixed(2)),
                    "sewer_Service_Charge":  Number(Number(el.sewer_Service_Charge).toFixed(2)),
                    "water_Service_Charge":  Number(Number(el.water_Service_Charge).toFixed(2)),
                    "total_Cost": Number(Number(el.total_Cost).toFixed(2))
                }
                StructuredData.push(lineitem);
                UnstructuredData.push(lineitem1);
            });
            FilteredData1 = UnstructuredData;
            FilteredData = StructuredData.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
            FilteredData.forEach(lineitem => {
                var trItem = <tr>
                <td>{lineitem.invoiceDate}</td>
                <td>{lineitem.on_Peak_kw}</td>
                <td>{lineitem.off_Peak_kw}</td>
                <td>{lineitem.kWh_Total}</td>
                <td>{lineitem.kWh_Cost}</td>
                <td>{lineitem.tonHr_Total}</td>
                <td>{lineitem.tonHr_Cost}</td>
                <td>{lineitem.heating_mmBTU}</td>
                <td>{lineitem.heating_mmBTU_Cost}</td>
                <td>{lineitem.total_mmBTU}</td>
                <td>{lineitem.om_Utility_Service_Charge}</td>
                <td>{lineitem.om_Capital_Service_Charge}</td>
                <td>{lineitem.sewer_Service_Charge}</td>
                <td>{lineitem.water_Service_Charge}</td>
                <td style={{'font-weight':'bolder'}}>{lineitem.total_Cost}</td>
                </tr>
                ItemRows.push(trItem);    
            });
            var kWh_Total = Number(FilteredData1.reduce((prev, next) => prev + (next.kWh_Total), 0)).toFixed(2);
            var kWh_Cost = Number(FilteredData1.reduce((prev, next) => prev + Number(next.kWh_Cost), 0)).toFixed(2);
            var tonHr_Total = Number(FilteredData1.reduce((prev, next) => prev + (next.tonHr_Total), 0)).toFixed(2);
            var tonHr_Cost = Number(FilteredData1.reduce((prev, next) => prev + (next.tonHr_Cost), 0)).toFixed(2);
            var heating_mmBTU = Number(FilteredData1.reduce((prev, next) => prev + (next.heating_mmBTU), 0)).toFixed(2);
            var heating_mmBTU_Cost = Number(FilteredData1.reduce((prev, next) => prev + (next.heating_mmBTU_Cost), 0)).toFixed(2);
            var total_mmBTU = Number(FilteredData1.reduce((prev, next) => prev + (next.total_mmBTU), 0)).toFixed(2);
            var om_Utility_Service_Charge = Number(FilteredData1.reduce((prev, next) => prev + (next.om_Utility_Service_Charge), 0)).toFixed(2);
            var om_Capital_Service_Charge = Number(FilteredData1.reduce((prev, next) => prev + (next.om_Capital_Service_Charge), 0)).toFixed(2);
            var sewer_Service_Charge = Number(FilteredData1.reduce((prev, next) => prev + (next.sewer_Service_Charge), 0)).toFixed(2);
            var water_Service_Charge = Number(FilteredData1.reduce((prev, next) => prev + (next.water_Service_Charge), 0)).toFixed(2);
            var total_Cost = Number(FilteredData1.reduce((prev, next) => prev + (next.total_Cost), 0)).toFixed(2);
            FilteredData.push({
                checkboxfield: '',
                invoiceDate: 'Total',
                on_Peak_kw: this.calculateColMax('on_Peak_kw') + "(max)",
                off_Peak_kw: this.calculateColMax('off_Peak_kw') + "(max)",
                kWh_Total: Conversions.formatNumber(PreferedDateFormat, kWh_Total),
                kWh_Cost: "$" + Conversions.formatNumber(PreferedDateFormat, kWh_Cost),
                tonHr_Total: Conversions.formatNumber(PreferedDateFormat, tonHr_Total),
                tonHr_Cost: "$" + Conversions.formatNumber(PreferedDateFormat, tonHr_Cost),
                heating_mmBTU: Conversions.formatNumber(PreferedDateFormat, heating_mmBTU),
                heating_mmBTU_Cost: "$" + Conversions.formatNumber(PreferedDateFormat, heating_mmBTU_Cost),
                total_mmBTU: Conversions.formatNumber(PreferedDateFormat, total_mmBTU),
                om_Utility_Service_Charge: "$" + Conversions.formatNumber(PreferedDateFormat, om_Utility_Service_Charge),
                om_Capital_Service_Charge: "$" + Conversions.formatNumber(PreferedDateFormat, om_Capital_Service_Charge),
                sewer_Service_Charge: "$" + Conversions.formatNumber(PreferedDateFormat, sewer_Service_Charge),
                water_Service_Charge: "$" + Conversions.formatNumber(PreferedDateFormat, water_Service_Charge),
                total_Cost: "$" + Conversions.formatNumber(PreferedDateFormat, total_Cost)
            })

            var trItem = <tr id="tr_last_child" style={{'font-weight':'bolder'}}>
            <td>{'Total'}</td>
            <td>{this.calculateColMax('on_Peak_kw') + "(max)"}</td>
            <td>{this.calculateColMax('off_Peak_kw') + "(max)"}</td>
            <td>{Conversions.formatNumber(PreferedDateFormat, kWh_Total)}</td>
            <td>{"$" + Conversions.formatNumber(PreferedDateFormat, kWh_Cost)}</td>
            <td>{Conversions.formatNumber(PreferedDateFormat, tonHr_Total)}</td>
            <td>{"$" + Conversions.formatNumber(PreferedDateFormat, tonHr_Cost)}</td>
            <td>{Conversions.formatNumber(PreferedDateFormat, heating_mmBTU)}</td>
            <td>{"$" + Conversions.formatNumber(PreferedDateFormat, heating_mmBTU_Cost)}</td>
            <td>{Conversions.formatNumber(PreferedDateFormat, total_mmBTU)}</td>
            <td>{"$" + Conversions.formatNumber(PreferedDateFormat, om_Utility_Service_Charge)}</td>
            <td>{"$" + Conversions.formatNumber(PreferedDateFormat, om_Capital_Service_Charge)}</td>
            <td>{"$" + Conversions.formatNumber(PreferedDateFormat, sewer_Service_Charge)}</td>
            <td>{"$" + Conversions.formatNumber(PreferedDateFormat, water_Service_Charge)}</td>
            <td style={{'font-weight':'bold'}}>{"$" + Conversions.formatNumber(PreferedDateFormat, total_Cost)}</td>
            </tr>

            ItemRows.push(trItem);

            CampusInvoiceDetailTable = <div className="table_container table_border" id="divASUPrintWindow" style={{'margin-bottom':'0px', 'margin-right':'15px','margin-left':'15px'}}>
            <Table striped responsive className="Custom_table fixed_layout" >
                <tbody className="cell_container">
                    <tr>
                            <th className="asu_print_th asu_print_th_0" width="90px">Invoice Date</th>
                            <th className="asu_print_th">On-Peak<br/> kW</th>
                            <th className="asu_print_th">Off-Peak<br/> kW</th>
                            <th className="asu_print_th">kWh<br/> Total</th>
                            <th className="asu_print_th">kWh<br/> Cost</th>
                            <th className="asu_print_th asu_print_th_6">TonHr<br/> Total</th>
                            <th className="asu_print_th asu_print_th_7">TonHr<br/> Cost</th>
                            <th className="asu_print_th asu_print_th_8">Heating<br/> mmBTU</th>
                            <th className="asu_print_th asu_print_th_9">Heating<br/> mmBTU<br/> Cost</th>
                            <th className="asu_print_th asu_print_th_10">Total<br/> mmBTU</th>
                            <th className="asu_print_th asu_print_th_11" width="87px">{"O&M Utility"}<br/>Service<br/>Charge</th>
                            <th className="asu_print_th asu_print_th_12" width="92px">{"O&M Capital"}<br/>Service<br/>Charge</th>
                            <th className="asu_print_th asu_print_th_13">Sewer <br/>Service<br/> Charge</th>
                            <th className="asu_print_th asu_print_th_14">Water <br/>Service <br/>Charge</th>
                            <th style={{'font-weight':'bold'}} >Total <br/>Cost</th>
                    </tr>
                    {ItemRows}
                </tbody>
            </Table>
        </div>

           
        }else{
            CampusInvoiceDetailTable = <div className="table_container table_border" id="divASUPrintWindow" style={{'margin-bottom':'0px', 'margin-right':'15px','margin-left':'15px'}}>
            <Table striped responsive className="Custom_table fixed_layout" >
                <tbody className="cell_container">
                    <tr>
                            <th className="asu_print_th asu_print_th_0" width="90px">Invoice Date</th>
                            <th className="asu_print_th">On-Peak<br/> kW</th>
                            <th className="asu_print_th">Off-Peak<br/> kW</th>
                            <th className="asu_print_th">kWh<br/> Total</th>
                            <th className="asu_print_th">kWh<br/> Cost</th>
                            <th className="asu_print_th asu_print_th_6">TonHr<br/> Total</th>
                            <th className="asu_print_th asu_print_th_7">TonHr<br/> Cost</th>
                            <th className="asu_print_th asu_print_th_8">Heating<br/> mmBTU</th>
                            <th className="asu_print_th asu_print_th_9">Heating<br/> mmBTU<br/> Cost</th>
                            <th className="asu_print_th asu_print_th_10">Total<br/> mmBTU</th>
                            <th className="asu_print_th asu_print_th_11" width="87px">{"O&M Utility"}<br/>Service<br/>Charge</th>
                            <th className="asu_print_th asu_print_th_12" width="92px">{"O&M Capital"}<br/>Service<br/>Charge</th>
                            <th className="asu_print_th asu_print_th_13">Sewer <br/>Service<br/> Charge</th>
                            <th className="asu_print_th asu_print_th_14">Water <br/>Service <br/>Charge</th>
                            <th style={{'font-weight':'bold'}}>Total <br/>Cost</th>
                    </tr>
                    <tr><td colSpan="7"/><td colSpan="5">No Records Found</td></tr>
                </tbody>
            </Table>
        </div>
        }

       

        return (
            <div className="main_container">
                <div className="border_container">&nbsp;
                    <div className="main_container" style={{ 'padding-top': '0px' }}>
                        <div className="row row_padding" style={{ 'padding-bottom': '20px' }}>
                            <div className="col-md-12">
                                <span style={{ 'color': '#3C5E99', 'font-size': '14px' }} onClick={() => { this.toggleCampusInvoiceList() }}> {" < "} </span> <span className="asu-linkText" onClick={() => { this.toggleCampusInvoiceList() }}> Back to Campus Invoices</span>
                            </div>
                        </div>
                        <div className="row row_padding" style={{ 'margin-right': '0px', 'padding-bottom': '20px' }}>
                            <div className="col-md-12" style={{ 'padding-right': '0px' }}>
                                <label className="lbl_asu_heading"> {SiteName} </label>
                                <div class="ASUdropdown" style={{float:'right', marginLeft:'8px'}}>
                                    <button type="button" class="btn-gray"><span className="ASUdropdowntxt">PRINT SCREEN</span><i className="arrowi down" style={{float:'right'}}></i></button>
                                    <div class="ASUdropdown-content">
                                        <a onClick={this.OpenPrintPreview}>Print...</a>
                                        <a onClick={() => {this.onExportInvoice()}}>Export as Excel</a>
                                    </div>
                                </div>
                                <div class="ASUdropdown" style={{float:'right', marginLeft:'20px'}}>
                                    <button type="button" class="btn-success"><span className="ASUdropdowntxt">DOWNLOAD INVOICE</span><i className="arrowi down" style={{float:'right'}}></i></button>
                                    <div class="ASUdropdown-content">
                                        <a onClick={() => { this.OnGenerateASUPDF() }}> Download as PDF</a>
                                        <a onClick={() => { this.DownloadExcel() }}>Download as Excel</a>
                                    </div>
                                </div>
                                {errormsg}
                            </div>

                        </div>
                        <div className="row row_padding" style={{ 'margin-right': '0px', 'padding-bottom': '20px' }}>
                            <div className="col-md-5">

                                <label style={{ "margin-right": "10px" }} className="lbl_asu_filter_text">Date:</label>
                                <label style={{ 'cursor': 'pointer' }}>
                                    <div className="pm_calendardiv" style={{ "margin-top": "0px" }}>
                                        <FaRegCalendarAlt className="pm_calendarbox" />
                                    </div>
                                    <DatePicker selected={this.state.FilterDate} onChange={date => this.setFilterDate(date)}
                                        id="FilterCalendar"
                                        onCalendarOpen={this.onFilterCalendarOpen}
                                        onCalendarClose={this.onFilterCalendarClose}
                                        dateFormat={"yyyy"}
                                        showYearPicker={true} />

                                </label>
                                <Button style={{ "margin-left": "15px" }} className="asu-applybutton" onClick={() => { this.OnFilterChange() }}>{"APPLY"}</Button>
                                {/* <label className="lbl_asu_filter_text">Display :</label>
                                <select ref='year_in_Select_input' style={{ "margin-left": "10px" }} className="pmminimal pm-dropdown" value={this.state.FilterYearValue} onChange={this.OnFilterYearChange}>
                                    {Filters_Year_in_Select_input}
                                </select> */}

                            </div>
                            <div className="col-md-7" style={{ 'padding-right': '0px' }}>
                                <span className="pm_outersearchbox" style={{ float: 'right' }}>
                                    <input type="text" className="pm_searchbox" style={{ paddingLeft: '10px', 'margin-top': '3px' }} placeholder="Enter value..." onChange={this.searchUpdated} ref='asu_campus_search_value' />
                                </span>
                                <label className="lbl_asu_filter_text" style={{ 'float': 'right', 'margin-top': '4px' }}>{"Search:"}</label>
                               
                            </div>
                           
                           
                        </div>
                        <div className="table_container table_border">
                            <div className="ag-theme-alpine" style={{ 'width': '100%' }} domLayout='autoHeight'>
                                <AgGridReact
                                    columnDefs={this.state.columnDefs}
                                    rowData={FilteredData}
                                    domLayout='autoHeight'
                                    overlayNoRowsTemplate='No Records Found'
                                    overlayLoadingTemplate='Loading...'
                                    suppressCellSelection={true}
                                    getRowClass={this.changeBottomRow}
                                    suppressMovableColumns={true}
                                    onGridReady={this.onGridReady.bind(this)}
                                    enableSorting={true}
                                >
                                </AgGridReact>
                            </div>
                        </div>
                        <div style={{"display":"none"}}>
                            {CampusInvoiceDetailTable}
                        </div>
                        <img id='Asu_Logo' alt="Trane1" src={ASULogo} style={{"display":"none"}} />
                    </div>
                </div>
            </div>
        );
    }
};
const mapStateToProps = state => {
    return {
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        CampusSelectedBuildingInvoice: state.ASUBillingInvoicesRootReducer.CampusSelectedBuildingInvoice,
        UserPreference_response: state.userPreferencesRootReducer.UserPreference

    };
};
const mapDispatchToProps = dispatch => {
    return {
        GetCampusBuildingInvoiceByBuildingId: (CampusBuildingId, Year) => dispatch(GetCampusBuildingInvoiceByBuildingId(CampusBuildingId, Year)),
        ASUGenerateSummaryInvoice: (data) => dispatch(ASUGenerateSummaryInvoice(data)),
        DownlodBuildingInvoiceExcel: (BuildingDetails) => dispatch(DownlodBuildingInvoiceExcel(BuildingDetails))
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ASUInvoicesForBuilding);